import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Box } from 'edenred-ui';
import { useTheme } from 'styled-components';

const MyChoiceDisclaimerContent = ({
  companyMyChoiceEnabled
}: {
  companyMyChoiceEnabled: boolean;
}) => {
  const { fontSemiBold } = useTheme();
  const { t } = useTranslation();
  return (
    <Box p={2} pt={0} whiteSpace="pre-line">
      <Trans
        i18nKey={`containers.benefit_groups.${
          companyMyChoiceEnabled ? '' : 'no_'
        }my_choice_disclaimer.content`}
        components={{
          bold: <Box fontWeight={fontSemiBold} display="inline-block" />,
          link1: (
            <a
              href={t(
                'containers.benefit_groups.no_my_choice_disclaimer.link1'
              )}
              target="_blank"
              rel="noopener noreferrer"
              title=""
            />
          ),
          link2: (
            <a
              href={t(
                'containers.benefit_groups.no_my_choice_disclaimer.link2'
              )}
              target="_blank"
              rel="noopener noreferrer"
              title=""
            />
          )
        }}
      />
    </Box>
  );
};

export { MyChoiceDisclaimerContent };
